import React from "react";
import { HashRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import ABBLogin from "./pages/cognien-pages/login/login";
import EMDashboard from "./pages/em-dashboard/em-dashboard";
import ChangePassword from "./pages/cognien-pages/change-password/change-passoword";
import Signup from "./pages/cognien-pages/signup/signup";
import NetZeroDashboard from "./pages/net-zero";
import MicrogridOpti from "./pages/micro-grid-opt";
import InputParameterSettings from "./pages/micro-grid-opt/input-parameters";
import NetworkPreview from "./components/Microgrid-Opt-Components/Network/network-preview";
import WNTDashboard from './pages/wide-area-network-twin';
import ConfigureSLD from './pages/wide-area-network-twin/configure-sld';
import SiteExplorer from "./pages/substation-explorer";
import CyberShield from './pages/cybershield';
import Navbar from "./components/Navbar/navbar";
import CognienDashboard from "../src/pages/cognien-pages/dashboard/dashboard";
import SubstationExplorer from "../src/pages/cognien-pages/substation-explorer";
import ManageUsers from "../src/pages/cognien-pages/user-management/manage-users";
import FullSld from "./components/cognien-components/SLD/full-sld";
import EditUser from "./pages/cognien-pages/user-management/edit-user";
import EvciEds from './pages/evci-eds';
// Import environment configuration
// Conditionally import admin panel components only in sandbox environment

// Component to conditionally render navbar
function AppLayout() {
  const location = useLocation();

  // Define routes where navbar should be shown
  const navbarRoutes = [
    '/settings',
    '/substation-explorer',
    '/substation-dashboard',
    '/sld-preview',
    '/edit-user'
  ];

  // Check if current path matches any navbar route
  const shouldShowNavbar = navbarRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      {shouldShowNavbar && (
        <>
          <Navbar />
          {/* <CognienNavbar /> */}

        </>

      )}
      <Routes>
        <Route path="/" element={<ABBLogin />} />
        <Route path="/site-explorer" element={<SiteExplorer />} />
        <Route path="/em" element={<EMDashboard />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route exact path="/signup" element={<Signup />} />
        <Route path="/nz" element={<NetZeroDashboard />} />

        <Route path="/microgrid-opt" element={<MicrogridOpti />} >
          <Route path="/microgrid-opt/input-settings" element={<InputParameterSettings />} />
        </Route>
        <Route path="/network-preview" element={<NetworkPreview />} />

        {/* Proofer tool */}

        <Route path="/wnt" element={<WNTDashboard />} />
        <Route path="/wnt/configure-sld" element={<ConfigureSLD />} />
        <Route path="cyber-shield" element={<CyberShield />} />
        <Route path="evci-eds" element={<EvciEds />} />
        
        {/* Custom Solution Viewer */}
        
        {/* Admin Panel with Sidebar - Only available in sandbox environment */}
                
        {/* Redirect admin routes in non-sandbox environments */}
        
        {/* Routes with Navbar */}
        <Route path="/settings" element={<ManageUsers />} />
        <Route path="/substation-explorer" element={<SubstationExplorer />} />
        <Route path="/substation-dashboard/*" element={<CognienDashboard />} />
        <Route path="/sld-preview" element={<FullSld />} />
        <Route path="/edit-user/*" element={<EditUser />} />
      </Routes>
    </>
  );
}

function CogniENRoutes() {
  return (
    <HashRouter>
      <AppLayout />
    </HashRouter>
  );
}

// Make sure to export as default
export default CogniENRoutes;